import allowed from '@/core/constants/allowed-roles.constant'
import { isRiskOverviewAllowedForCompany } from '@/core/constants/risk-overview-embed.constant'

const RISK_EXPOSURE_MODULE = 'core.menu.modules.risk-exposure'
const RISK_PROFILING_SUBMENU = 'core.menu.modules.risk-profiling'
const RISK_PROFILING_HOME = 'core.menu.modules.risk-profiling-home'

const RISK_DASHBOARD_MENU_ITEM = Object.freeze({
  name: 'core.menu.modules.risk-dashboard',
  route: '/risk-exposure/risk-overview',
  module: 'risk-profiling',
  allowedRoles: allowed.risk_profiling.roles,
  type: 'sub',
})

export function injectRiskOverviewMenuItemIfAllowed(localMenuItems, companyId) {
  if (!isRiskOverviewAllowedForCompany(companyId))
    return

  const riskExposure = localMenuItems.modules?.find(
    m => m.name === RISK_EXPOSURE_MODULE,
  )
  const riskProfiling = riskExposure?.children?.find(
    c => c.name === RISK_PROFILING_SUBMENU,
  )
  if (!riskProfiling?.children?.length)
    return

  const exists = riskProfiling.children.some(
    c =>
      c.name === RISK_DASHBOARD_MENU_ITEM.name
      || c.route === RISK_DASHBOARD_MENU_ITEM.route,
  )
  if (exists)
    return

  const overviewIndex = riskProfiling.children.findIndex(
    c => c.name === RISK_PROFILING_HOME,
  )
  const insertAt = overviewIndex >= 0 ? overviewIndex + 1 : 0
  riskProfiling.children.splice(insertAt, 0, { ...RISK_DASHBOARD_MENU_ITEM })
}
